module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_2257", [["div",{"class":"site-page terms"},[["section",{"class":"static-page-wrapper"},[["div",{"class":"title-block"},[["div",{"class":"page-width z6"},[["div",{"class":"title editor-wrapper","data-fox-alias":"2257Title","data-fox-context":"2257"},[["p",{},[["textNode",{"text":"CUSTODIAN OF RECORDS U.S.C. TITLE 18, SECTION 2257 COMPLIANCE"}]]]]]]]]],["section",{"class":"static-page-content"},[["div",{"class":"page-width static-page-docs"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/2257.tpl
// module id = 1061
// module chunks = 4